class DualPromoSliders extends HTMLElement {
  connectedCallback() {
    const initAll = () => {
      document.querySelectorAll('[data-dual-slider-swiper]').forEach((root) => {
        if (root.__dualInited) return;
        const slides = root.querySelectorAll('.swiper-slide').length;
        if (!slides) return;

        const paginationEl = root.parentElement?.querySelector?.('.dual-sliders__pagination') || null;

        new Swiper(root, {
          effect: 'fade',
          loop: slides > 1,
          speed: 700,
          threshold: 10,
          autoplay: slides > 1 ? { delay: 2500, disableOnInteraction: false } : false,
          pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined
        });

        root.__dualInited = true;
      });
    };

    const ensureSwiper = (cb) => {
      if (window.Swiper) { cb(); return; }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
      script.onload = cb;
      document.head.appendChild(link);
      document.head.appendChild(script);
    };

    const go = () => ensureSwiper(initAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', go, { once: true });
    } else {
      go();
    }
  }
}

if (!customElements.get('dual-promo-sliders')) {
  customElements.define('dual-promo-sliders', DualPromoSliders);
}

if (!document.querySelector('dual-promo-sliders')) {
  document.body.appendChild(document.createElement('dual-promo-sliders'));
}
